import React from 'react';
import Image from 'next/image';
import { Link } from '@/i18n/navigation';
import WBLogo from '@/../public/static/wb-partners.svg';
import { resolveUrl } from '@portal-root/geo-utils';
import { useParams } from 'next/navigation';
import { ECountry } from '@portals/help-center-core';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
import { getWindow } from '@/_utils';
import { useLocale } from '@/_hooks/use-locale';
import { getPortalLandingUrl } from './_utils/get-logo-href';
import { TRouteCommon } from '@/_constants/routes';

const cn = classnames.bind(styles);

const BLOCK_NAME = 'Logo';

export const Logo = () => {
  const { country } = useParams<TRouteCommon>();
  const locale = useLocale();
  const isChina = country === ECountry.CHINA;

  const currentOrigin = getWindow()?.location.origin;
  // TODO: добавить geoUtils https://youtrack.wildberries.ru/issue/INS-1819
  const href = isChina
    ? resolveUrl(currentOrigin?.replace(/\.ru$/, '.cn'))
    : resolveUrl(currentOrigin);

  const loginHref = getPortalLandingUrl({ href, locale, country });

  return (
    <Link
      className={cn(`${BLOCK_NAME}__link`)}
      href={loginHref}
      prefetch={false}
      target="_blank"
    >
      <Image
        alt=""
        className={cn(`${BLOCK_NAME}__img`)}
        height={24}
        src={WBLogo}
        width={24}
      />
    </Link>
  );
};
